import { render } from "./JobDetails.vue?vue&type=template&id=605dcfcd&ts=true"
import script from "./JobDetails.vue?vue&type=script&lang=ts"
export * from "./JobDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__